// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list","962":"home"}[chunkId] || chunkId) + "-" + {"137":"8f1952ff70d3f8ea3634","702":"67144b5fb83dd7f2615b","715":"f0c96475c29c190163a7","796":"c2f878543e210e1d2dc5","962":"ed1bd608ffaf5831a014"}[chunkId] + ".css";
};